<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                
                <div class="col-lg-3 col-sm-3 col-12">
                  <div class="form-group">
                    <label>Type of news</label>
                    <vue-select :options="tipe_news" v-model="currentData.tipe" placeholder="Select type" />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-3 col-12">
                  <div class="form-group">
                    <label>Directed to</label>
                    <vue-select :options="ditujukan_kepada_list" v-model="currentData.ditujukan_kepada"
                      placeholder="Select" />
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 col-12">
                  <div class="form-group" v-if="currentData.ditujukan_kepada == 'LOCATION'">
                    <div class="d-flex justify-content-between ">
                      <label>Location <span class="text-danger">*</span></label>
                    </div>

                    <multi-select :options="needData1" :selected-options="locations" style="z-index:504"
                      placeholder="select location" @select="onSelectLocations">
                    </multi-select>
                  </div>
                  <div class="form-group" v-if="currentData.ditujukan_kepada == 'EMPLOYEE'">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <!-- <model-select :options="data_marketing" placeholder="Select Marketing"
                      v-model="this.currentData.id_marketing" style="z-index:500" :isError="marketingCek">
                    </model-select> -->
                    <multi-select :options="needData2" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div>
                <div class="col-lg-12 col-sm-12 col-12" >
                  <div class="form-group">
                    <label>Title <span class="text-danger">*</span></label>
                    <input type="text" v-model="currentData.judul" placeholder="" required />
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12 col-12" v-if="currentData.tipe == 'EVENT'">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" id="tanggal" name="tanggal" v-model="currentData.tanggal">
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12 col-12" v-if="currentData.tipe == 'EVENT'">
                  <div class="form-group">
                    <label>Notify before event/news<span class="text-danger">*</span></label>
                    <div class="position-relative">
                      <input type="number" v-model="currentData.notif" placeholder="" max="100" required />
                      <div class="position-absolute end-0 top-0 me-5 mt-2">
                        minutes
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Deskripsi <span class="text-danger">*</span></label>
                    <textarea class="form-control" v-model="currentData.deskripsi" required>
                    </textarea>
                  </div>
                </div>
                <div class="col-lg-4 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Lampiran</label>
                    <input type="file" class="form-control" ref="lampiran" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Insert</button>
                  <router-link to="news" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="number"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="number"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch} from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';


export default {
  components: {

    ModelSelect,
    MultiSelect

  },
  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Insert News & Events",
      title1: "add new news and events",
      namaCompany: '',
      config: "",
      api: "",
      value: "",

      ditujukan_kepada_list: ['EMPLOYEE', 'LOCATION'],
      tipe_news: ['NEWS', 'EVENT'],

      //data
      currentData: {
        ditujukan_kepada: "LOCATION",
        tanggal: this.formatDateLocal(new Date()),
        notif: 0,
        tipe: 'NEWS',
      },
      currentDate: new Date,
      needData1: [],
      needData2: [],

      ///multi select
      locations: [],
      employees: [],

      lastSelectItemLocation: {},
      lastSelectItemEmployee: {},
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'insert')

    this.namaCompany = localStorage.getItem('namaCompany');

    this.preparedData();
    // this.LocationList.push({ id: 0, value: 0, text: 'SEMUA' });

  },
  
  methods: {
    // getCurrentDateTime() {
    //   const now = new Date();
    //   const year = now.getFullYear();
    //   const month = String(now.getMonth() + 1).padStart(2, '0');
    //   const day = String(now.getDate()).padStart(2, '0');
    //   const hours = String(now.getHours()).padStart(2, '0');
    //   const minutes = String(now.getMinutes()).padStart(2, '0');
    //   return `${year}-${month}-${day}T${hours}:${minutes}`;
    // },

    preparedData() {

      const needData1 = JSON.parse(localStorage.getItem('lokasiList'));

      needData1.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama_lokasi };
        this.needData1.push(item_prepare);
      });



      const needData2 = JSON.parse(localStorage.getItem('employeeList'));

      needData2.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama };
        this.needData2.push(item_prepare);
      });



    },
    onSelectLocations(items, lastSelectItem) {
      this.locations = items
      this.lastSelectItemLocation = lastSelectItem
    },
    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem
    },

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocal(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },

    async insert() {
     
      let formData = new FormData();
      appendForm(formData)

      Object.entries(this.currentData).forEach(([key, value]) => {
        formData.append(key, value);

      });

      formData.delete('lokasi_id');
      formData.delete('employee_id');

      formData.append('tanggal', this.formatDateLocal(this.currentData.tanggal))

     

      if (this.currentData.ditujukan_kepada == 'LOCATION') {
        let id_lokasi = [];
        this.locations.forEach((item, index) => {
          id_lokasi.push(item.value)
        });
        formData.append('lokasi_id', id_lokasi.join(','));
        formData.append('employee_id', null);

      } else {
        let employee_id = [];
        this.employees.forEach((item, index) => {
          employee_id.push(item.value)
        });
        formData.append('employee_id', employee_id.join(','));
        formData.append('lokasi_id', null);

      }



      formData.delete("lampiran");
      if (this.$refs.lampiran.value !== "") {
        formData.append("lampiran", this.$refs.lampiran.files[0]);
      }

       for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // return true;

      

      const api = base_url + '/v3/news/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
          AlertBottom(data.message);
          goPage('news');
          
          
      }else {
          AlertPopup2("error", "", data.message, true, 1500);
      }

      
      
    },

  },

};
</script>
